import { gql } from "@apollo/client";

export const GET_TICKET_VIOLATIONS = gql`
  query GET_TICKET_VIOLATIONS(
    $warnOnly: Boolean
    $timestamp: String
    $muniVios: Boolean
  ) {
    getTicketViolationPrototypes(
      warnOnly: $warnOnly
      timestamp: $timestamp
      muniVios: $muniVios
    ) {
      id
      inactive
      maxPenalty
      minPenalty
      fullName
      name
      oriId
      points
      waiver
      code
      position
      section
      statute
      title
      civilViolation
      municipalOrdinance
      speedingVio
      ticketCategory {
        id
        name
      }
      ticketSubCategory {
        id
        name
      }
      ticketEntry {
        id
        name
      }
      doNotSubmit
    }
  }
`;
